/**
 * Canonicalize a garment color DISPLAY NAME into its identity key.
 *
 * Color identity in the pseudo-supplier path is `color_sku`: a display
 * name ("Athletic Heather", "Navy") with spaces and mixed case, NO
 * slugging, a soft string, and no foreign key. The name a superadmin
 * types on the SKU setup page becomes the `color_name` on
 * `local_garment_images`, which is what the render path later looks the
 * blank photo up by.
 *
 * WHY THIS EXISTS RATHER THAN storing what was typed. `color_converter.csv`
 * carries stray whitespace on 18 rows (`BlkHthr` -> `"Black Heather "`)
 * and a double space on a couple (`"Heather  Blue"`). The backend already
 * canonicalizes at the write boundary --
 * `LocalGarmentImage.validate_color_name` routes through
 * `normalize_display_whitespace` (`color_name_normalization.py:42`) -- so
 * a name typed with a trailing space is stored WITHOUT it. A UI that kept
 * the raw string would show a color whose key does not match the row the
 * backend actually wrote, and the lookup would silently miss: the color
 * renders a tinted silhouette instead of its real flat-lay.
 *
 * This is the FRONTEND HALF of that same canonicalization, deliberately
 * byte-identical to the Python: strip surrounding whitespace, collapse
 * every internal whitespace run to a single space. Case is PRESERVED --
 * this is an identity key built from a display name, not a match key.
 * (Contrast `normalizeColorNameForMatch` in ColorsPanel.vue, which
 * lowercases and folds slash padding because it is comparing against a
 * supplier catalog. Different job, deliberately not shared.)
 *
 * Keep this in lockstep with `normalize_display_whitespace`. If the
 * Python side changes, this changes with it in the same PR.
 *
 * @param {string} name raw color display name as typed
 * @returns {string} the canonical key; "" for null/undefined/empty
 */
export function canonicalColorSkuKey(name) {
    if (typeof name !== "string" || !name) return "";
    return name.replace(/\s+/g, " ").trim();
}

export default canonicalColorSkuKey;
